import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PartialAcceptTime } from 'server/shared/models/partialAcceptTime';

@Component({
  selector: 'app-job-partial-time-chip',
  templateUrl: './job-partial-time-chip.component.html',
  styleUrls: ['./job-partial-time-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobPartialTimeChipComponent {
  @Input() partialAcceptTime?: PartialAcceptTime;
  constructor() {}
}
